const url = process.env.VUE_APP_API_URL

export default {
    account: url + '/Account/',
    activation: url + '/Activation/',
    activity: url + '/Activity/',
    article: url + '/Article/',
    cart: url + '/Cart/',
    accountsetting: url + '/AccountSetting/',
    discountCode: url + '/DiscountCode/',
    download: url + '/Download/',
    email: url + '/Email/',
    enum: url + '/Enum/',
    license: url + '/License/',
    licenseAssignment: url + '/LicenseAssignment/',
    licenseKey: url + '/LicenseKey/',
    login: url + '/token',
    oem: url + '/OEM/',
    order: url + '/Order/',
    orderDetails: url + '/OrderDetails/',
    orderStatus: url + '/OrderStatus/',
    payment: url + '/Payment/',
    product: url + '/Product/',
    productCategory: url + '/ProductCategory/',
    productLine: url + '/ProductLine/',
    productSupport: url + '/ProductSupport/',
    revision: url + '/Revision/',
    roles: url + '/Roles/',
    status: url + '/Status/',
    webinar: url + '/Webinar/',
    autoactivation: url + '/AutoActivation/',
    notifyError: url + '/Errors/NotifyError',
    error: url + '/Errors/',
}
